import React from "react";
import { SearchCriterion } from "../common/SearchCriterion";
import { CompositeDropdown } from "./CompositeDropdown";
import { criteriaElementsType, requiredRolesType } from "../../../../common/types/search/search";

interface CompositeCriterionProps {
	label: string;
	criteria?: criteriaElementsType;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
}

export function CompositeCriterion({
	label,
	requiredRoles,
	criteria,
	prefix,
	quickSearch = false,
}: CompositeCriterionProps) {
	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
		>
			<CompositeDropdown
				label={label}
				criteria={criteria}
				quickSearch={quickSearch}
			/>
		</SearchCriterion>
	);
}
